module.exports = __webpack_public_path__ + "../resources/img/mask-copy-2.82b7472d.svg";